// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__FndfJ","startDate":"startDate__2MOvm","startDateM":"startDateM__1np5j","startDateMContent":"startDateMContent__2hOdC","point":"point__2H4vB"};


//////////////////
// WEBPACK FOOTER
// ./components/start-date/style.styl
// module id = fWTg
// module chunks = 0